import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';

export default class CheckIpApi {
  static check() {
    return axiosNonAuth.post(`${settings.apiBaseUrl}/ip/check/`);
  }
}
